import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from "react";
import { connect } from "react-redux";
import { Button, Typography, CardMedia, CardContent, CardActions, Card } from "@material-ui/core";
export var SecurityModal = /*#__PURE__*/function (_React$Component) {
  _inherits(SecurityModal, _React$Component);

  var _super = _createSuper(SecurityModal);

  function SecurityModal() {
    var _this;

    _classCallCheck(this, SecurityModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.goBack = function () {
      _this.props.history.goBack();
    };

    return _this;
  }

  _createClass(SecurityModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Card, {
        style: {
          maxWidth: 350,
          margin: "0 auto",
          display: "block",
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement(CardMedia, {
        style: {
          height: 160
        },
        image: require("./warning.png"),
        title: "Contemplative Reptile"
      }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
        gutterBottom: true,
        variant: "h5",
        component: "h2"
      }, "Sorry, You do not have permission to view this page"), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        component: "p"
      }, "This may be due to your security access level not permitting you to access this page or this page does not exist. Please contact your administrator.")), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Button, {
        size: "small",
        color: "primary",
        onClick: function onClick() {
          _this2.goBack();
        }
      }, "Return to Previous Page")));
    }
  }]);

  return SecurityModal;
}(React.Component);
export default connect(function (store) {
  return {};
}, {})(SecurityModal);